import { useEffect } from "react";
import { swipeBehavior } from "@telegram-apps/sdk-react";

export function useTelegramScreen() {
  useEffect(() => {
    if (
      swipeBehavior.isSupported() &&
      swipeBehavior.disableVertical?.isAvailable?.()
    ) {
      swipeBehavior.disableVertical();
    }
  }, []);
}
